import { Drawer } from 'antd';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { MenuUnfoldOutlined } from '@ant-design/icons';
import { useState } from 'react';

import EPIconButton from '@/components/EPButton/EPIconButton';

import AddAssetSelectorDrawerContainer from './AddAssetSelectorDrawer.styles';
import AssetItem from './AssetItem/AssetItem';
import { assetItemIconMapping } from './AddAssetSelectorDrawer.utils';
import AddAssetDrawer from './AddAssetDrawer/AddAssetDrawer';

interface AddAssetSelectorDrawerProps {
  isAddAssetSelectorDrawerOpen: boolean;
  setIsAddAssetSelectorDrawerOpen: (isAddAssetSelectorDrawerOpen: boolean) => void;
  diagramContainerRef: React.RefObject<HTMLDivElement>;
}

const AddAssetSelectorDrawer = observer(
  ({
    isAddAssetSelectorDrawerOpen,
    setIsAddAssetSelectorDrawerOpen,
    diagramContainerRef,
  }: AddAssetSelectorDrawerProps) => {
    const { t } = useTranslation();
    const [selectedDeviceType, setSelectedDeviceType] = useState<string>(null);

    const handleAddAssetOpenDrawer = (deviceType: string) => () => setSelectedDeviceType(deviceType);

    const onClose = () => setIsAddAssetSelectorDrawerOpen(false);

    const onMouseAction = e => e.stopPropagation();

    return (
      <Drawer
        open={isAddAssetSelectorDrawerOpen}
        onClose={onClose}
        width={400}
        closeIcon={false}
        destroyOnClose
        push={false}
        mask={false}
        getContainer={diagramContainerRef.current}
        rootStyle={{ position: 'absolute' }}
      >
        <AddAssetSelectorDrawerContainer
          onMouseDown={onMouseAction}
          onMouseUp={onMouseAction}
          onTouchStart={onMouseAction}
          onTouchEnd={onMouseAction}
          onWheel={onMouseAction}
        >
          <div className="header">
            <span className="header-title">{t('addNewAssets')}</span>
            <EPIconButton icon={<MenuUnfoldOutlined />} onClick={onClose} size="large" />
          </div>
          <div className="body">
            <span className="body-title">{t('availableAssets')}</span>
            <div className="assets">
              {Object.entries(assetItemIconMapping).map(([key, value]) => (
                <AssetItem icon={value?.icon} title={key} key={key} onClick={handleAddAssetOpenDrawer(key)} />
              ))}
            </div>
          </div>
        </AddAssetSelectorDrawerContainer>
        <AddAssetDrawer
          selectedDeviceType={selectedDeviceType}
          parentContainerRef={diagramContainerRef}
          setIsAddAssetSelectorDrawerOpen={setIsAddAssetSelectorDrawerOpen}
          setSelectedDeviceType={setSelectedDeviceType}
        />
      </Drawer>
    );
  },
);

export default AddAssetSelectorDrawer;
